<div class="min-h-[calc(100vh-12rem)] flex flex-col items-center justify-center text-center px-4">
  <div class="max-w-2xl mx-auto backdrop-blur-xl bg-white/30 p-8 rounded-2xl border border-white/50 shadow-lg">
    <div class="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-primary-300 to-primary-600 rounded-2xl shadow-lg flex items-center justify-center">
      <i class="pi pi-search text-2xl text-white"></i>
    </div>

    <h1 class="text-4xl font-bold text-slate-800 mb-4">
      404 - Stranica nije pronađena
    </h1>

    <p class="text-lg text-slate-600 mb-8">
      Stranica koju tražite ne postoji ili je premještena.
    </p>

    <div class="flex justify-center">
      <a
        routerLink="/"
        class="p-button p-component bg-gradient-to-br from-primary-300 to-primary-600 text-white font-semibold px-6 py-2 rounded-lg hover:opacity-90 transition-opacity"
      >
        <i class="pi pi-home mr-2"></i>
        Povratak na početnu
      </a>
    </div>
  </div>
</div>